import { FiTrendingUp, FiBell, FiCloud } from 'react-icons/fi'
import Card from './ui/Card'
import SectionTitle from './ui/SectionTitle'
import Reveal from './ui/Reveal'

const services = [
  {
    icon: FiTrendingUp,
    title: 'Monitoramento em Tempo Real',
    description: 'Acompanhamento contínuo do volume em seus reservatórios com dados precisos e atualizados instantaneamente.',
  },
  {
    icon: FiBell,
    title: 'Alertas Automáticos',
    description: 'Sistema inteligente de notificações para níveis críticos e manutenção preventiva, garantindo segurança operacional.',
  },
  {
    icon: FiCloud,
    title: 'Armazenamento em Nuvem',
    description: 'Todos os dados são armazenados de forma segura e acessíveis de qualquer lugar, a qualquer momento.',
  },
]

const Services = () => {
  return (
    <section id="services" className="section-padding section-alt relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.04]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(34, 198, 94, 0.06) 1px, transparent 0)',
        backgroundSize: '32px 32px',
      }} />

      <div className="container-custom relative z-10">
        <Reveal direction="up">
          <SectionTitle
            title="Nossos Serviços"
            subtitle="Soluções Completas"
            align="center"
          />
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 w-full min-w-0">
          {services.map((service, index) => {
            const Icon = service.icon
            return (
              <Reveal key={index} direction="up" delay={index * 100}>
                <Card hover padding="lg" className="text-center group h-full flex flex-col relative overflow-hidden card-glow-border transition-all duration-300 hover:shadow-lg">
                  <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-accent/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div 
                    className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-2xl mb-4 flex-shrink-0 mx-auto transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-accent/20 bg-gradient-to-br from-accent/25 to-accent/10 dark:from-accent/30 dark:to-accent/15"
                  >
                    <Icon className="w-7 h-7 sm:w-8 sm:h-8 text-accent group-hover:text-accent-dark transition-colors" />
                  </div>
                  <h3 className="text-base sm:text-lg font-extrabold text-gray-900 dark:text-white mb-2 flex-shrink-0 tracking-tight">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-sm sm:text-base flex-grow font-medium">
                    {service.description}
                  </p>
                </Card>
              </Reveal>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Services
